import { ModalUI } from "../ModalUI";

interface IProps {
    onClose(): void;
}
export const HelpModal: React.FC<IProps> = ({ onClose }) => {

    const resolveHelpMessage = () => {
        switch (window.location.pathname) {
            case '/':
                return (
                    <div className="p-4">
                        <p className="interactions-text mb-3 font-bold text-sm">
                            Arrow Keys: <span className="font-normal">Move</span>
                        </p>
                        <p className="interactions-text mb-3 font-bold text-sm">
                            X & Z: <span className="font-normal">Actions</span>
                        </p>
                        <p className="interactions-text mb-3 font-bold text-sm">
                            Space / Enter: <span className="font-normal">Start</span>
                        </p>
                        <p className="interactions-text font-bold text-sm">
                            Esc: <span className="font-normal">Home</span>
                        </p>
                    </div>
                );
            case '/build':
                return (
                    <div className="p-4">
                        <p className="interactions-text mb-2 font-bold text-sm text-center">
                            Use the Developer Sandbox to write your game code and test that it works with WowBoi.
                        </p>
                        <p className="interactions-text mb-2 font-bold text-sm text-center">
                            Then when your code is ready, follow the Inscribe instructions!
                        </p>
                    </div>
                );
            case '/assets':
                return (
                    <div className="p-4">
                        <p className="interactions-text text-sm text-center mb-4 max-w-[600px]">
                            WowBoi Trademarked Assets. <br /><br /> Available for use on Social Media / Websites. <br /><br />These assets remain the property of WowBoi™.
                        </p>
                    </div>
                );
            case '/leader':
                return <>... about the Leaderboard</>;
        }
    }

    return (
        <ModalUI maxHeight={240} maxWidth={380} onClose={onClose}>
            {resolveHelpMessage()}
        </ModalUI>
    )
}
